import { ajaxSend } from '../../../api/api';

export function getPresigned(file: any) {
  return ajaxSend({
    path: '/v1/uploads/presigned_url/organization_avatar',
    method: 'POST',
    data: {
      pretty_name: file.name,
      content_type: file.type,
    },
  });
}

export function getOrganization(organizationID: string) {
  return ajaxSend({
    method: 'GET',
    path: `/v1/organizations/${organizationID}`,
  });
}

export function getOrganizationFeatureFlags(organizationID: string) {
  return ajaxSend({
    path: `/v1/organizations/${organizationID}/temporary/featureflags`,
  });
}

export function editOrganization(id: string, payload: any) {
  return ajaxSend({
    method: 'PATCH',
    data: payload,
    path: `/v1/organizations/${id}`,
  });
}

export function uploadAvatar(presigned: any, file: any) {
  return ajaxSend({
    path: presigned.upload_url,
    method: 'PUT',
    headers: {
      authorization: null,
      contentType: file.type,
    },
    data: file,
  });
}

export function changeSimultaneousRinging(enabled: boolean) {
  return ajaxSend({
    method: 'PUT',
    path: '/v1/presence/simultaneous_ring',
    data: {
      enabled: enabled,
    },
  });
}
